export default "__VITE_ASSET__DjgTanbG__"